enum ChatRoomsEnum {
	APP = 'APP',
	SAC = 'SAC',
	SAC_ODONTO = 'SAC_ODONTO',
	EXAMS = 'EXAMS',
	ODONTO = 'ODONTO',
	DEBIT_NEGOTIATION = 'DEBIT_NEGOTIATION',
	BANK_SLIP = 'BANK_SLIP',
	BE_BORN_WELL = 'C_NASCER_BEM',
}

const CHAT_ROOMS_HAP: Record<ChatRoomsEnum, string> = {
	[ChatRoomsEnum.APP]: 'C_APP_BETA',
	[ChatRoomsEnum.SAC]: 'C_SAC_APP_BETA',
	[ChatRoomsEnum.SAC_ODONTO]: 'C_SAC_ODONTO_APP_BETA',
	[ChatRoomsEnum.EXAMS]: 'C_APP_EXAMES_BETA',
	[ChatRoomsEnum.ODONTO]: 'C_APP_ODONTO_BETA',
	[ChatRoomsEnum.DEBIT_NEGOTIATION]: 'CHAT_COBRANCA_SITE',
	[ChatRoomsEnum.BANK_SLIP]: 'CHAT_2_VIA_BOLETO_SITE',
	[ChatRoomsEnum.BE_BORN_WELL]: 'C_NASCER_BEM',
};

const CHAT_ROOMS_CCG: Record<ChatRoomsEnum, string> = {
	[ChatRoomsEnum.APP]: 'C_APP_BETA_CCG',
	[ChatRoomsEnum.SAC]: 'C_SAC_APP_BETA_CCG',
	[ChatRoomsEnum.SAC_ODONTO]: 'C_SAC_ODONTO_BETA_CCG',
	[ChatRoomsEnum.EXAMS]: 'C_APP_EXAMES_BETA_CCG',
	[ChatRoomsEnum.ODONTO]: 'C_APP_ODONTO_BETA_CCG',
	[ChatRoomsEnum.DEBIT_NEGOTIATION]: 'CHAT_COBRANCA_SITE',
	[ChatRoomsEnum.BANK_SLIP]: 'CHAT_2_VIA_BOLETO_SITE',
	[ChatRoomsEnum.BE_BORN_WELL]: 'C_NASCER_BEM',
};

const CHAT_ROOMS_CLINIPAM: Record<ChatRoomsEnum, string> = {
	[ChatRoomsEnum.APP]: 'C_APP_BETA_CLINIPAM',
	[ChatRoomsEnum.SAC]: 'C_SAC_APP_BETA_CLINIPAM',
	[ChatRoomsEnum.SAC_ODONTO]: 'C_SAC_ODONTO_APP_BETA_CLINIPAM',
	[ChatRoomsEnum.EXAMS]: 'C_APP_EXAMES_BETA_CLINIPAM',
	[ChatRoomsEnum.ODONTO]: 'C_APP_ODONTO_BETA_CLINIPAM',
	[ChatRoomsEnum.DEBIT_NEGOTIATION]: 'CHAT_COBRANCA_SITE',
	[ChatRoomsEnum.BANK_SLIP]: 'CHAT_2_VIA_BOLETO_SITE',
	[ChatRoomsEnum.BE_BORN_WELL]: 'C_NASCER_BEM',
};

const CHAT_ROOMS_GNDI_MINAS: Record<ChatRoomsEnum, string> = {
	[ChatRoomsEnum.APP]: 'C_APP_BETA_NDIMINAS',
	[ChatRoomsEnum.SAC]: 'C_SITE_SAC_NDIMINAS',
	[ChatRoomsEnum.SAC_ODONTO]: 'C_SAC_ODONTO_APP_BETA_NDIMINAS',
	[ChatRoomsEnum.EXAMS]: 'C_SITE_EXAMES_NDIMINAS',
	[ChatRoomsEnum.ODONTO]: 'C_SITE_CONSULTAS_NDIMINAS',
	[ChatRoomsEnum.DEBIT_NEGOTIATION]: 'CHAT_COBRANCA_SITE',
	[ChatRoomsEnum.BANK_SLIP]: 'CHAT_2_VIA_BOLETO_SITE',
	[ChatRoomsEnum.BE_BORN_WELL]: 'C_NASCER_BEM',
};

const CHAT_ROOMS_GNDI_SAO_PAULO: Record<ChatRoomsEnum, string> = {
	[ChatRoomsEnum.APP]: 'C_NDISP_SITE_CONSULTAS',
	[ChatRoomsEnum.SAC]: 'C_NDISP_SITE_SAC',
	[ChatRoomsEnum.SAC_ODONTO]: 'C_NDISP_SITE_SAC_ODONTO',
	[ChatRoomsEnum.EXAMS]: 'C_NDISP_SITE_EXAMES',
	[ChatRoomsEnum.ODONTO]: 'C_NDISP_SITE_ODONTO',
	[ChatRoomsEnum.DEBIT_NEGOTIATION]: 'CHAT_NDISP_NEGOCIACAO',
	[ChatRoomsEnum.BANK_SLIP]: 'CHAT_NDISP_SEGUNDA_VIA_BOLETO',
	[ChatRoomsEnum.BE_BORN_WELL]: 'C_NASCER_BEM',
};

const CHAT_ROOMS_NOTREDAME_SAUDE: Record<ChatRoomsEnum, string> = {
	[ChatRoomsEnum.APP]: 'C_NOTREDAMESAUDE_SITE_CONSULTAS',
	[ChatRoomsEnum.SAC]: 'C_NOTREDAMESAUDE_SITE_SAC',
	[ChatRoomsEnum.SAC_ODONTO]: 'C_NOTREDAMESAUDE_SITE_SAC_ODONTO',
	[ChatRoomsEnum.EXAMS]: 'C_NOTREDAMESAUDE_SITE_EXAMES',
	[ChatRoomsEnum.ODONTO]: 'C_NOTREDAMESAUDE_SITE_ODONTO',
	[ChatRoomsEnum.DEBIT_NEGOTIATION]: 'CHAT_NOTREDAMESAUDE_NEGOCIACAO',
	[ChatRoomsEnum.BANK_SLIP]: 'CHAT_NOTREDAMESAUDE_SEGUNDA_VIA_BOLETO',
	[ChatRoomsEnum.BE_BORN_WELL]: 'C_NASCER_BEM',
};

export type ChatRoomsType = typeof CHAT_ROOMS_HAP;

export {
	CHAT_ROOMS_HAP,
	CHAT_ROOMS_CCG,
	CHAT_ROOMS_CLINIPAM,
	CHAT_ROOMS_GNDI_MINAS,
	CHAT_ROOMS_GNDI_SAO_PAULO,
	CHAT_ROOMS_NOTREDAME_SAUDE,
	ChatRoomsEnum,
};
